import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import { iconSizes } from "./constants";
import { IconWrapper } from "./IconWrapper";
export var Icon = forwardRef(function (_a, ref) {
    var Component = _a.svgComponent, dangerouslySetSvg = _a.dangerouslySetSvg, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a["aria-hidden"], ariaHidden = _c === void 0 ? true : _c, _d = _a.role, role = _d === void 0 ? "presentation" : _d, clientId = _a.clientId, children = _a.children, props = __rest(_a, ["svgComponent", "dangerouslySetSvg", "size", "aria-hidden", "role", "clientId", "children"]);
    var height = props.height || iconSizes[size];
    var width = props.width || iconSizes[size];
    if (process.env.NODE_ENV !== "production") {
        var renderableProps = [
            children ? "children" : null,
            Component ? "Component" : null,
            dangerouslySetSvg ? "dangerouslySetSvg" : null,
        ].filter(Boolean);
        if (renderableProps.length > 1) {
            console.warn("Icon: please pass only one of children, svgComponent, or dangerouslySetSvg, got [" + renderableProps.join(", ") + "]");
        }
    }
    if (Component) {
        return (React.createElement(IconWrapper, __assign({ height: height, width: width, "aria-hidden": ariaHidden, role: role, ref: ref, "data-client-id": clientId }, props),
            React.createElement(Component, null)));
    }
    else if (dangerouslySetSvg) {
        return (React.createElement(IconWrapper, __assign({ height: height, width: width, "aria-hidden": ariaHidden, role: role, ref: ref, "data-client-id": clientId }, props, { dangerouslySetInnerHTML: {
                __html: dangerouslySetSvg
            } })));
    }
    else if (children) {
        return (React.createElement(IconWrapper, __assign({ height: height, width: width, "aria-hidden": ariaHidden, role: role, ref: ref, "data-client-id": clientId }, props), children));
    }
    return null;
});
Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map